import { BaseService } from 'core/services';
import HolidayRouteService from './HolidayRouteService';

class HolidayService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new HolidayRouteService());
    }
}

export default HolidayService;
